module.exports = __webpack_public_path__ + "static/media/CreateQuizM.2466fe93.svg";